<div class="{{wrapSelector}}">
    <a href="#" class="clearButton clearButton--grey">
        <span class="icon">
            <span class="alt">{{clearFieldText}}</span>
        </span>
    </a>
</div>